import api, { handleApiError, fetchAllDataRest } from './client';

export const courseOfferService = {
  /**
   * Get all course offers with pagination and filters
   */
  getAll: async (
    page = 1,
    limit = 10,
    nameFilter = null,
    isPayPerUse = null,
    courseId = null,
    exportAll = false,
    offerType = null,
    archiveFilter = null
  ) => {
    try {
      const queryParams = {
        page,
        limit,
        nameFilter: nameFilter || undefined,
        isPayPerUse: isPayPerUse !== null ? isPayPerUse : undefined,
        courseId: courseId || undefined,
        offerType: offerType || undefined,
        archiveFilter: archiveFilter || undefined,
      };

      if (exportAll) {
        return await fetchAllDataRest('/api/course-offers', queryParams, 'abbonamenti');
      }

      const response = await api.get('/api/course-offers', { params: queryParams });
      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      console.error('Get course offers error:', error);
      return handleApiError(error, 'Errore nel caricamento degli abbonamenti');
    }
  },

  /**
   * Get course offer by ID
   */
  getById: async (id) => {
    try {
      const response = await api.get(`/api/course-offers/${id}`);
      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      console.error('Get course offer error:', error);
      return handleApiError(error, "Errore nel caricamento dell'abbonamento");
    }
  },

  /**
   * Create new course offer
   */
  create: async (courseOfferData) => {
    try {
      const response = await api.post('/api/course-offers', courseOfferData);
      return {
        success: true,
        data: response.data,
        message: 'Abbonamento creato con successo',
      };
    } catch (error) {
      console.error('Create course offer error:', error);
      return handleApiError(error, "Errore nella creazione dell'abbonamento");
    }
  },

  /**
   * Update course offer
   */
  update: async (id, courseOfferData) => {
    try {
      const response = await api.put(`/api/course-offers/${id}`, courseOfferData);
      return {
        success: true,
        data: response.data,
        message: 'Abbonamento corso aggiornato con successo',
      };
    } catch (error) {
      console.error('Update course offer error:', error);
      return handleApiError(error, "Errore nell'aggiornamento dell'abbonamento corso");
    }
  },

  /**
   * Delete course offer
   */
  delete: async (id) => {
    try {
      await api.delete(`/api/course-offers/${id}`);
      return {
        success: true,
        message: 'Abbonamento corso eliminato con successo',
      };
    } catch (error) {
      console.error('Delete course offer error:', error);
      return handleApiError(error, "Errore nell'eliminazione dell'abbonamento corso");
    }
  },

  /**
   * Archive or restore a course offer
   */
  archive: async (id, isArchived) => {
    try {
      const response = await api.post(`/api/course-offers/${id}/archive`, { isArchived });
      return {
        success: true,
        data: response.data?.success ?? true,
        message: isArchived ? 'Abbonamento archiviato con successo' : 'Abbonamento ripristinato con successo',
      };
    } catch (error) {
      console.error('Archive course offer error:', error);
      return handleApiError(error, "Errore nell'archiviazione dell'abbonamento");
    }
  },

  /**
   * Get course offers summary for select component
   */
  getCourseOffersSummary: async (courseId, searchTerm = '') => {
    try {
      const response = await api.get('/api/course-offers/summary', {
        params: { courseId, searchTerm: searchTerm || undefined },
      });
      const items = response.data?.items || response.data || [];
      return {
        success: true,
        data: items,
      };
    } catch (error) {
      console.error('Get course offers summary error:', error);
      return handleApiError(error, 'Errore nel caricamento del riassunto degli abbonamenti');
    }
  },
};

export default courseOfferService;
